import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';

function ProfileVisiblity({ status }) {
  const [profileVisible, setProfileVisible] = useState(status !== 'draft');

  return (
    <div className="input areas-served-wrapper">
      <label className="" htmlFor="user_area_ids">
        Profile Visibility
      </label>

      <select
        aria-label="Agent Status Input"
        className="hidden"
        name="user[agent_status]"
        id="user_agent_status"
        value={profileVisible ? 'published' : 'draft'}
      >
        <option value="draft" selected={profileVisible === false}>
          Draft
        </option>
        <option value="published" selected={profileVisible === true}>
          Published
        </option>
      </select>

      <div className="profile-visibility-container">
        <p>{`Your profile is currently ${
          profileVisible ? 'visible' : 'hidden'
        }`}</p>
        <Toggle
          icons={false}
          className="inquiry-settings-toggle"
          checked={profileVisible}
          onChange={() => setProfileVisible(!profileVisible)}
        />
      </div>
    </div>
  );
}

ProfileVisiblity.propTypes = {
  status: PropTypes.oneOf(['draft', 'published']).isRequired,
};

export default ProfileVisiblity;
